import {observable, action, runInAction, computed} from 'mobx'
import {json, get} from '../../../../utils/ajax'
import {findChildren, objToValueObj, setStore} from '../../../../utils/Utils'
import {message} from "antd";

class EPCCarDirectoryStore {

    @observable list
    @observable page
    @observable tree
    @observable modal
    @observable editFields
    @observable info
    @observable option
    @observable brands
    @observable carSeries
    @observable modalSelect
    @observable brandId
    @observable carSeriesId
    @observable editCarseriesCode
    @observable loading
    @observable brand
    @observable carSerie
    @observable editCarSeriesId
    @observable editBrandid
    @observable saveData
    @observable level
    @observable editCatalogueLoading
    @observable showDrawer
    @observable carseriesName
    @observable importReturnData
    @observable rightTable
    @observable index
    @observable rowData
    @observable selectedRowKeys
    @observable forms
    @observable modelStatus
    @observable editRowData
    @observable addSelModal  //新增车系模态框
    @observable addBoxModal  //新增车系模态框
    @observable optionModal
    @observable dragState //是否显示拖拽后保存按钮
    @observable expandedLeftRowKeys//扩展的左行键
    @observable stLevel1DirectoryIDOnTheLeft//左侧1级目录ID

    constructor() {
        this.modal = false
        this.modalSelect = false
        this.list = []
        this.page = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.info = []
        this.option = []
        this.tree = []
        this.editFields = {}
        this.brands = {
            list: [],
            selected: '',
        }
        this.carSeries = {
            list: [],
            selected: ''
        }
        this.brandId = []
        this.carSeriesId = []
        this.editCarseriesCode = []
        this.loading = false
        this.brand = {}
        this.carSerie = {}
        this.editCarSeriesId = ''
        this.saveData = ''
        this.level = 0
        this.editCatalogueLoading = false
        this.showDrawer = false
        this.carseriesName = ''
        this.importReturnData = []
        this.rightTable = []
        this.index = []
        this.rowData = {}
        this.selectedRowKeys = []
        this.forms = {}
        this.modelStatus = false
        this.editRowData = {}
        this.addSelModal = false
        this.addBoxModal = false
        this.optionModal = ''
        this.dragState = false
        this.expandedLeftRowKeys = []
        this.stLevel1DirectoryIDOnTheLeft = ''
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /**
     * 初始化页面
     */
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesCatalog/queryListByPage`, {
            page: page - 1,
            carseriesName: '',
            size: this.page.pageSize
        })
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res.content || []
            this.rightTable = []
            this.page = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

    /**
     * 删除车系记录
     */
    @action
    deleteByCarseriesId = async (id) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/carseriesCatalog/${id}`)
        if (res && res.status === 0) {
            return
        }
        await this.initListPage(this.page)
    }
    /**
     * 发布
     * @param rocord
     * @returns {Promise.<void>}
     */
    @action
    publishByCarseriesId = async (rocord) => {
        let code = rocord.carSeriesCode;
        let state = rocord.state ? 0 : 1;
        if (rocord.state === 0) {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/carsystem`)
            let list = Array.isArray(res) ? res.find((item) => item === code) : []
            if (list !== undefined) {
                await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/carseriesCatalog/${rocord.id}/state/${state}`)
            } else {
                message.warning('品牌管理未发布')
            }
        }
        this.initListPage(this.page)
    }

    /**
     * 撤销
     * @param rocord
     * @returns {Promise<void>}
     */
    @action
    revokeByCarseriesId = async (rocord) => {
        let state = rocord.state ? 0 : 1;
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/carseriesCatalog/${rocord.id}/state/${state}`)
        this.initListPage(this.page)
    }

    /**
     * 初始化品牌下拉框
     */
    @action
    initBrands = async () => {
        runInAction(() => {
            this.carSeries = {
                list: [],
                selected: ''
            }
            this.addSelModal = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/get/all`)
        runInAction(() => {
            this.brands.list = Array.isArray(res) ? res : []
            let brand = this.brands.list.find((item) => item.defaultName === '')
            let value = brand && brand.defaultName
            this.initCarseries(value)
        })
    }

    /**
     * 初始化车系下拉框
     */
    @action
    initCarseries = async (value) => {
        let brand = this.brands.list.find((item) => item.defaultName === value)
        let ids = brand && brand.id
        if (!ids) {
            return
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/carsystem/ids`, {ids})
        runInAction(() => {
            this.carSeries.list = Array.isArray(res) ? res : []
            this.brand = brand
        })
    }

    @action
    selectCarseries = (value) => {
        let carSerie = this.carSeries.list.find((item) => item.defaultName === value)
        this.carSerie = carSerie
    }


    /**
     * 选中品牌
     */
    @action
    saveBrandId = (value) => {
        runInAction(() => {
            this.brandId = value
        })
    }

    /**
     * 选中车系
     */
    @action
    saveCarSeriesId = (value) => {
        runInAction(() => {
            this.carSeriesId = value
        })
    }

    /**
     * 保存选中的车系和品牌记录
     */
    @action
    saveCatalog = async () => {
        const data = {
            'carseriesName': this.carSerie.defaultName,
            'carSeriesCode': this.carSerie.carSeriesCode,
            'carseriesImage': this.carSerie.icon,
            'brandId': this.brand.id,
            'brandName': this.brand.defaultName,
            'carseriesId': this.carSerie.id,
            'state': 0,
            'language': this.carSerie.language,
            'enCarseriesName': this.carSerie.enName,
            'enDescribe': this.carSerie.enDescribe,
            'describe': this.carSerie.defaultDescription,
            'rank': this.carSerie.rank
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/carseriesCatalog`, data)
        runInAction(() => {
            this.addSelModal = false
        })
        this.initListPage(0)
    }

    /**
     *
     *
     * 下面为查看目录页面操作
     *
     *
     **/

    /**
     *
     *清空目录
     */
    @action.bound
    clearEditPage() {
        runInAction(() => {
            this.modal = false
        })
        this.tree = []
    }

    /**
     *
     *初始化目录树表
     */
    @action
    initEditPage = async (record) => {
        this.loading = true
        this.saveData = record
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/queryListByCarCode?carCode=${record.carSeriesCode}`)
        runInAction(() => {
            this.tree = Array.isArray(res) ? findChildren(res) : []
            this.editCarseriesCode = record.carSeriesCode
            this.editCarSeriesId = record.carSeriesId
            this.editBrandid = record.id
            this.rowData = {}
            this.loading = false
        })
    }

    /***
     * epc目录查询->删除
     * */
    @action
    deleteOne = async (record) => {
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/delById/id/${record.id}`)
        runInAction(() => {
            this.initEditPage(this.saveData)
        })


    }

    //Box************************************************************************************************************* */

    //ShowBox
    @action
    showBox = (record, option) => {
        runInAction(() => {
            if (option === 'update') {
                this.editFields = objToValueObj(record)
            } else {
                this.editFields = {}
            }
            this.loading = true
            this.info = record
            this.option = option
            this.optionModal = option === 'addSame' ? '新增同级' : option === 'update' ? '修改' : '新增下级'
            this.modal = true
            this.loading = false
        })
    }

    @computed
    get fields() {
        let fields = {
            code: {value: this.editFields.code},
            name: {value: this.editFields.name},
            description: {value: this.editFields.description},
        }
        return fields
    }

    //Cast
    @action
    onEditFieldChange(changedFields) {
        this.editFields = {...this.editFields, ...changedFields}
    }

    /**
     * 新增同级/下级
     * @param content
     * @param option
     * @returns {Promise.<void>}
     */
    @action
    operation = async (content) => {
        let info = this.info
        this.loading = true
        let data = {
            'id': this.editBrandid,
            'carseriesId': this.editCarSeriesId,
            'carseriesCode': this.editCarseriesCode,
            'name': content.name,
            'code': content.code,
            'description': content.description,
        }
        if (this.option === 'addSame') {//添加同级
            data.level = info.level
            data.pid = info.pid
            let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/addSameLevel`, data)
            if (res && res.status === 0) {
                message.warning('章节验证中不存在此数据！')
                this.loading = false
                return
            }
        } else if (this.option === 'addChild') {//添加下级
            data.level = info.level + 1
            data.pid = info.id
            let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/addSubordinate`, data)
            if (res && res.status === 0) {
                message.warning('章节验证中不存在此数据！')
                this.loading = false
                return
            }
            this.level = res.level
        } else if (this.option === 'update') {//修改
            data.id = info.id
            data.level = info.level
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/updateLv3Catalog`, data)
            if (res.status) {
                message.success(`修改成功！`)
            } else {
                message.warning(`该目录已存在，请勿重新添加!`)
            }
            this.getRightLevel1Data(this.editCarseriesCode)
        }
        runInAction(() => {
            this.loading = false
            this.modal = false
            this.getRightData(this.rowData)
            this.initEditPage(this.saveData)
        })
    }

    /**
     *取消编辑
     */
    @action.bound
    cancelEdit() {
        this.loading = false
        this.modalSelect = false
        this.addSelModal = false
    }

    //HideBox
    @action
    closeBox = () => {
        this.modal = false
    }

    //Show Add Lv1 Catalog Box
    @action
    showAddFirstBox = () => {
        runInAction(() => {
            this.option = 'addFrist'
            this.loading = true
            this.editFields = {}
            this.modal = true
            this.loading = false
        })
    }

    /**
     * 添加同级下级时回显数据
     * @param value
     */
    @action
    echoChapterMainData = async (value) => {
        this.loading = true
        this.editCatalogueLoading = true
        let data = {
            code: value,
            isSubordinate: this.option !== "addSame",
            path: this.info.path
        }
        if (data.code === "") {
            return
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/chapterMain/getChapterByPathAndCode`, data)
        if (res.name == null) {
            message.warning('章节验证中不存在此数据！')
        }
        runInAction(() => {
            this.editFields = {
                ...this.editFields,
                name: {value: res.name},
                description: {value: res.description}
            }
            this.editCatalogueLoading = false
            this.loading = false
        })
    }

    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    /***
     * 关闭抽屉
     */
    @action
    onClose = () => {
        this.showDrawer = false
    }

    /**
     * 获取右边表格数据
     * @param record
     * @returns {Promise<void>}
     */
    @action
    getRightData = async (record) => {
        this.rowData = record
        if (record.level < 3) {
            this.loading = true
            this.selectedRowKeys = []
            const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/querySonData?carCode=${this.carSeriesCode}&&pid=${record.id}`)
            runInAction(() => {
                this.rightTable = res
                this.loading = false
                this.rightTable.forEach(item => {
                    if (item.isRelease === 1) {
                        this.selectedRowKeys.push(item.id)
                    }
                })
            })
        }
    }

    /**
     * 获取右边一级表格数据
     * @param record
     * @returns {Promise<void>}
     */
    @action
    getRightLevel1Data = async (carSeriesCode) => {
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/queryTheLevel1DirectoryAccordingToTheCarCode?carCode=${carSeriesCode}`)
        runInAction(() => {
            this.rightTable = res
            this.loading = false
        })
    }

    @action
    getRowData = (arr, id) => {
        arr.forEach(item => {
            if (item.children !== '' && item.id !== id) {
                this.index = this.getRowData(item.children, id)
            } else if (item.id === id) {
                this.index = item.children
            }
        })
        return this.index
    }

    //保存可隐藏的数据
    @action
    saveSelectedRowKeys = (selectedRowKeys, selectedRows) => {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
    }

    //保存
    @action
    saveCatalogIsShow = async () => {
        const res1 = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/querySonData?carCode=${this.carSeriesCode}&&pid=${this.rowData.id}`)
        let list = []
        runInAction(() => {
            this.selectedRowKeys.map(item => {
                let data = res1.find(i => item === i.id)
                data && list.push(data)
            })
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/modifyReleaseStatus/carCode?carCode=${this.carSeriesCode}&&mainId=${this.rowData.id}`, list)
        if (res.status) {
            runInAction(() => {
                message.success('操作成功')
                this.rowData && this.getRightData(this.rowData)
            })
        }
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormsChange = (changedFields) => {
        this.forms = {...this.forms, ...changedFields}
    }

    /**
     * 修改
     * @param record
     */
    @action
    editSparePart = (record) => {
        this.editRowData = record
        this.forms = {
            name: {value: record.name},
            description: {value: record.description},
        }
    }

    @action
    saveEdit = async () => {
        let data = {
            id: this.editRowData.id,
            name: this.forms.name.value,
            description: this.forms.description.value
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/updateLv3Catalog`, data)
        if (res.status) {
            message.success(`修改成功！`)
            this.getRightData(this.rowData)
            // this.initEditPage(this.saveData)
        }
    }

    /***
     * 保存排序
     * @returns {Promise<void>}
     */
    @action
    saveSort = async () => {
        let dragList = []
        this.rightTable.forEach((item, index) => {
            dragList.push({
                id: item.id,
                sort: index + 1
            })
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/modifySort`, dragList)
        if (res && res.status === 0) {
            message.error('保存失败');
            return
        }
        runInAction(() => {
            message.success('排序成功');
            this.initEditPage(this.saveData)
            this.dragState = false
        })
    }
}

export default new EPCCarDirectoryStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/EPC/EPCCatalogManager/store.js